const CircularLoader = () => <div className="spinner-loader"></div>;

export default CircularLoader